module.exports = __webpack_public_path__ + "static/media/ic-info-white-24-px.10a33a42.svg";